class Share {
  /**
   * @param {HTMLElement} element - the sharing element
   */
  constructor(element) {
    this.element = element;

    this.config = {
      selectors: {
        shareButton: ".js-Share-networkLink",
      },
    };

    this.windowWidth = 600;
    this.windowHeight = 400;

    this.shareButtons = [
      ...element.querySelectorAll(this.config.selectors.shareButton),
    ];

    this._handleClick = this._handleClick.bind(this);

    this._bind();
  }

  /**
   * binds events
   *
   * @private
   */
  _bind() {
    this.shareButtons.forEach((shareButton) => {
      shareButton.addEventListener("click", this._handleClick);
    });
  }

  /**
   * handle mouse clicks:
   * opens the facebook/bluesky window with given sizes in the center of the screen
   *
   * @param {object} event - event
   * @private
   */
  _handleClick(event) {
    event.preventDefault();
    const windowTop =
      window.top.outerHeight / 2 + window.top.screenY - this.windowHeight / 2;
    const windowLeft =
      window.top.outerWidth / 2 + window.top.screenX - this.windowWidth / 2;
    const { href } = event.target.closest(this.config.selectors.shareButton);
    const features = `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=${this.windowHeight},width=${this.windowWidth},top=${windowTop},left=${windowLeft}`;

    window.open(href, "", features);
  }
}

export default Share;
